module.exports = __webpack_public_path__ + "static/media/img_flipCards-02.6f19cb4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/flipbox/img_flipCards-02.png
// module id = 437
// module chunks = 4